import React from "react";

interface StatsCardsProps {
    totalExhibited: number;
    selectedCount: number;
    dirtyCount: number;
    avgAdjustmentStr: string;
    cycleYear: number;
}

export const StatsCards: React.FC<StatsCardsProps> = ({
    totalExhibited,
    selectedCount,
    dirtyCount,
    avgAdjustmentStr,
    cycleYear,
}) => {
    return (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "14px", marginBottom: "22px" }}>
            <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "12px", padding: "16px 18px" }}>
                <div style={{ fontSize: "12px", color: "#94a3b8" }}>Clientes exibidos</div>
                <div style={{ fontSize: "22px", fontWeight: 700, color: "#1e293b", marginTop: "3px" }}>
                    {totalExhibited}
                </div>
            </div>

            <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "12px", padding: "16px 18px" }}>
                <div style={{ fontSize: "12px", color: "#94a3b8" }}>Selecionados</div>
                <div style={{ fontSize: "22px", fontWeight: 700, color: "#0d9488", marginTop: "3px" }}>
                    {selectedCount}
                </div>
            </div>

            <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "12px", padding: "16px 18px" }}>
                <div style={{ fontSize: "12px", color: "#94a3b8" }}>Com alterações pendentes</div>
                <div style={{ fontSize: "22px", fontWeight: 700, color: "#d97706", marginTop: "3px" }}>
                    {dirtyCount}
                </div>
            </div>

            <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "12px", padding: "16px 18px" }}>
                <div style={{ fontSize: "12px", color: "#94a3b8" }}>Reajuste médio ciclo {cycleYear}</div>
                <div style={{ fontSize: "22px", fontWeight: 700, color: "#1e293b", marginTop: "3px" }}>
                    {avgAdjustmentStr}
                </div>
            </div>
        </div>
    );
};
